import { useAuthStore } from '@/lib/store/auth'
import { LoginDialog } from './login-dialog'

export function GlobalLoginDialog() {
  const isLoginDialogOpen = useAuthStore((s) => s.isLoginDialogOpen)
  const closeLoginDialog = useAuthStore((s) => s.closeLoginDialog)

  return (
    <LoginDialog
      open={isLoginDialogOpen}
      onClose={closeLoginDialog}
      onSuccess={closeLoginDialog}
    />
  )
}
